import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

import ErrorPage from '@/containers/Pages/Error.vue'
import UserAuth from '@/components/UserAuth'
import Games from '@/components/Games'
import DashboardStudent from '@/components/DashboardStudent'
import Dashboard from '@/components/Dashboard'
import { Role } from '@/constants'
import { getToken, removeToken } from '@/helpers/token'

Vue.use(VueRouter)

let routes = [
	{
		path: '/reset-password',
		name: 'Reset password',
		component: UserAuth.Recovery,
		meta: { public: true },
	},
	{
		path: '/activate/:param1/:param2',
		component: Dashboard.Activate,
		name: 'Activate',
		meta: { public: true },
	},
	{
		path: '/',
		component: UserAuth.Wrapper,
		meta: { requiresAuth: false },
		children: [
			{
				path: '',
				name: 'Sign page',
				component: UserAuth.Sign,
			},
			{
				path: '/login',
				name: 'Login',
				component: UserAuth.Sign,
			},
		],
	},
	{
		path: '/demo',
		component: Games.Wrapper,
		meta: { requiresAuth: false },
		children: [
			{
				path: 'addition',
				component: Games.Settings.Addition,
			},
			{
				path: 'columns',
				component: Games.Settings.Columns,
			},
			{
				path: 'game',
				component: Games.Game,
			},
			{
				path: 'abacus-game',
				component: Games.Abacus,
			},
		],
	},
	{
		path: '/games/',
		component: Games.Wrapper,
		meta: { requiresAuth: true },
		children: [
			{
				path: '',
				name: 'Game list',
				component: Games.List,
			},
			{
				path: 'homework',
				name: 'Game Homework',
				component: Games.Homework,
			},
			{
				path: 'anzan',
				name: 'Anzan',
				component: Games.Settings.Anzan,
			},
			{
				path: 'addition',
				name: 'AddSub',
				component: Games.Settings.Addition,
			},
			{
				path: 'mul-base',
				name: 'Multiply Base',
				component: Games.Settings.MulBase,
			},
			{
				path: 'mul-25x25',
				name: '25x25',
				component: Games.Settings.Mul25x25,
			},
			{
				path: 'columns',
				name: 'Negative columns',
				component: Games.Settings.Columns,
			},
			{
				path: 'squared',
				name: 'Squared',
				component: Games.Settings.Squared,
			},
			{
				path: 'multiply',
				name: 'Multiply',
				component: Games.Settings.Mul,
			},
			{
				path: 'division',
				name: 'Division',
				component: Games.Settings.Division,
			},
			{
				path: 'negative',
				name: 'Negative',
				component: Games.Settings.Negative,
			},
			{
				path: 'game',
				name: 'Game',
				component: Games.Game,
			},
			{
				path: 'abacus-game',
				name: 'Abacus Game',
				component: Games.Abacus,
			},
			{
				path: 'abacus-random',
				name: 'Abacus Random',
				component: Games.Settings.AbacusRandom,
			},
		],
	},
	{
		path: '/dashboard/',
		component: Dashboard.Wrapper,
		meta: { requiresAuth: true },
		children: [
			{
				path: 'list/:role',
				component: Dashboard.List,
				name: 'Dashboard List',
			},
			{
				path: 'list/:role/:type',
				component: Dashboard.List,
				name: 'Dashboard Deactivated List',
			},
			{
				path: 'add/:role',
				component: Dashboard.Add,
				name: 'Dashboard Add',
			},
			{
				path: 'profile/:id',
				component: Dashboard.Profile,
				name: 'Dashboard Profile',
			},
			{
				path: 'profile/:id/homework',
				component: Dashboard.HomeworkCalendar,
				name: 'Profile Homework',
			},
			{
				path: 'profile/:id/homework/create',
				component: Dashboard.HomeworkCreate,
				name: 'Profile Homework Create',
			},
			{
				path: 'group/:id',
				component: Dashboard.Group,
				name: 'Dashboard Group Profile',
			},
			{
				path: 'group/:id/homework',
				component: Dashboard.HomeworkCalendar,
				name: 'Group Homework',
			},
			{
				path: 'group/:id/homework/create',
				component: Dashboard.HomeworkCreate,
				name: 'Group Homework Create',
			},
			{
				path: 'reports/:id',
				component: Dashboard.Reports,
				name: 'Dashboard Reports',
			},
			{
				path: 'lessons',
				component: Dashboard.Lessons,
				name: 'Dashboard Lessons',
			},
			{
				path: 'lessons/:id',
				component: Dashboard.Lesson,
				name: 'Dashboard Lesson',
			},
			{
				path: 'restore',
				component: Dashboard.Restore,
				name: 'Dashboard Restore',
			},
			{
				path: 'lesson/add',
				component: Dashboard.AddLesson,
				name: 'Dashboard Add Lesson',
			},
			{
				path: 'settings',
				component: Dashboard.Settings,
				name: 'Dashboard Settings',
			},
			{
				path: 'storage',
				component: Dashboard.Storage,
				name: 'Dashboard Storage',
			},
		],
	},
	{
		path: '/dashboard-student/',
		component: DashboardStudent.Wrapper,
		meta: { requiresAuth: true },
		children: [
			{
				path: '',
				name: 'Dashboard Student Main',
				component: DashboardStudent.Main,
			},
			{
				path: 'statistic',
				name: 'Dashboard Student Statistic',
				component: DashboardStudent.Statistic,
			},
			{
				path: 'shop',
				name: 'Dashboard Student Shop',
				component: DashboardStudent.Shop,
			},
			{
				path: 'history',
				name: 'Dashboard Student History',
				component: DashboardStudent.History,
			},
			{
				path: 'contract',
				name: 'Dashboard Student Contract',
				component: Dashboard.StaticPage,
			},
			{
				path: 'homework',
				name: 'Dashboard Student Homework',
				component: Dashboard.HomeworkCalendar,
			},
			{
				path: 'training',
				name: 'Dashboard Student Homework',
				component: Games.List,
				props: true,
			},
			{
				path: 'lesson/:id',
				name: 'Dashboard Student Lesson',
				component: DashboardStudent.Lesson,
			},
		],
	},
	{
		path: '/:static',
		component: Dashboard.StaticPage,
		name: 'Static Page',
		meta: { public: true },
	},
	{
		path: '*',
		component: ErrorPage,
		name: '404',
	},
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
})

router.beforeEach((to, from, next: any) => {
	let userToken = getToken()
	let userRole =
		window.localStorage.getItem('userProfile') === null
			? null
			: JSON.parse(window.localStorage.getItem('userProfile') as any).role

	// If only one data saved -- remove all, send user to Sign page
	if ((!userToken && userRole) || (userToken && !userRole)) {
		userToken = null
		userRole = null

		removeToken()
		window.localStorage.removeItem('userProfile')
	}

	/**
	 * User can access one or more levels smaller, than its role
	 */
	const premissionRole = () => {
		if (((Role[userRole] as unknown) as number) === Role.teacher) {
			return 'group'
		}

		return Role[((Role[userRole] as any) as number) - 1]
	}

	const pageOrUserRole = () => {
		if (!to.params.role) {
			return false
		}
		return Role[to.params.role as any] >= Role[userRole as any]
	}

	if (to.matched.some(m => m?.meta?.public)) {
		next()
		return
	}

	if (to.matched.some(m => m.meta.requiresAuth)) {
		if (!userToken) {
			next({ name: 'Sign page' })
		} else if (to.name === 'Dashboard List' || to.fullPath === '/dashboard') {
			if (userRole === 'student' || userRole === 'parent') {
				next({ name: 'Dashboard Student Main' })
			} else if (!to.params.role) {
				next({ name: 'Dashboard List', params: { role: premissionRole() } })
			} else {
				next()
			}
		} else if (to.name === 'Dashboard Restore') {
			next(
				((Role[userRole] as any) as number) > Role.parent
					? undefined
					: '/dashboard'
			)
		} else if (
			to.name === 'Dashboard Settings' ||
			to.name === 'Dashboard Add Lesson'
		) {
			if (userRole !== 'super franchise') {
				next({ name: 'Dashboard List', params: { role: premissionRole() } })
			} else {
				next()
			}
		} else if (pageOrUserRole()) {
			next({ name: 'Dashboard List', params: { role: premissionRole() } })
		} else if (
			to.fullPath === '/games/game' &&
			!Object.keys(store.state.gameConfig).length
		) {
			next('/games')
		} else {
			next()
		}
	} else if (to.matched.some(m => !m.meta.requiresAuth)) {
		if (userToken) {
			if (userRole === 'student') {
				next({ name: 'Dashboard Student Main' })
			} else {
				next({ name: 'Dashboard List', params: { role: premissionRole() } })
			}
		} else {
			next()
		}
	} else {
		next()
	}
})

export default router
